import { z } from 'zod';

import { DelinquentInterestSettingId } from '../BrandedIds';
import { InvestorRemittanceSplit } from '../loan/InvestorRemittanceSplit';
import { zodDateOrString } from '../utils';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UpdateDelinquentInterestRateEvent = BaseLoanEvent.extend({
  type: z.literal('updateDelinquentInterestRate'),
  delinquentInterestSettingId: DelinquentInterestSettingId.optional(),
  delinquentInterestRate: z.number(),
  effectiveDate: zodDateOrString,
  endDate: zodDateOrString.nullable().optional(),
  delinquentInterestDeferred: z.boolean().optional(),
  delinquentInterestWaived: z.boolean().optional(),
  investorRemittanceSplit: InvestorRemittanceSplit.optional(),
  comment: z.string().optional(),
});

export type UpdateDelinquentInterestRateEvent = z.infer<typeof UpdateDelinquentInterestRateEvent>;
